export const MAX_TASK_IMAGE_BYTES = 1 * 1024 * 1024;

export const TASK_IMAGE_ONLY_MESSAGE = 'Only image attachments are allowed';
export const TASK_IMAGE_SIZE_MESSAGE = 'Image size must be less than 1MB';

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg', '.heic', '.heif'];

const hasImageExtension = (filename) => {
  const name = filename?.toLowerCase() ?? '';
  return IMAGE_EXTENSIONS.some((ext) => name.endsWith(ext));
};

const isBlockedNonImageMime = (mimetype) => {
  if (!mimetype) return false;
  const blockedPrefixes = ['application/pdf', 'application/zip', 'text/', 'video/', 'audio/'];
  return blockedPrefixes.some(
    (prefix) => mimetype === prefix || mimetype.startsWith(prefix)
  );
};

export const isTaskSubmissionImage = (file) => {
  if (!file) return false;

  if (isBlockedNonImageMime(file.type)) {
    return false;
  }

  if (file.type?.startsWith('image/')) {
    return true;
  }

  if (!file.type && hasImageExtension(file.name)) {
    return true;
  }

  return false;
};

/**
 * Validates file type first, then size. Returns error message or null.
 */
export const validateTaskSubmissionImageFile = (file) => {
  if (!file) return null;

  if (!isTaskSubmissionImage(file)) {
    return TASK_IMAGE_ONLY_MESSAGE;
  }

  if (file.size > MAX_TASK_IMAGE_BYTES) {
    return TASK_IMAGE_SIZE_MESSAGE;
  }

  return null;
};
